"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Location_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Location = void 0;
const dcterms_1 = require("lincd-dcmi/lib/ontologies/dcterms");
const rdf_1 = require("lincd-rdf/lib/ontologies/rdf");
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const xsd_1 = require("lincd-xsd/lib/ontologies/xsd");
const models_1 = require("lincd/lib/models");
const Shape_1 = require("lincd/lib/shapes/Shape");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const titan_ads_1 = require("../ontologies/titan-ads");
const package_1 = require("../package");
let Location = Location_1 = class Location extends Shape_1.Shape {
    static loadAll() {
        return Server_1.Server.call(package_1.packageName, 'loadAll', Location_1.shape.namedNode);
    }
    static fromQuoraResponse(response) {
        const URI = process.env.DATA_ROOT + '/' + encodeURIComponent(response.quoraId);
        const locationNode = models_1.NamedNode.getOrCreate(URI);
        locationNode.overwrite(rdf_1.rdf.type, titan_ads_1.titanAds.Location);
        const newLocation = new Location_1(locationNode);
        // If the location has some data populated, we know it already exists,
        // so we can return it early
        if (newLocation.geotype)
            return newLocation;
        const nameSegments = [];
        Object.entries(response).forEach(([key, value]) => {
            if (value instanceof Object && 'displayField' in value)
                nameSegments.push(key);
        });
        newLocation.name = nameSegments
            .map((segment) => response[segment].displayField)
            .join(', ');
        newLocation.geotype = response.geoType;
        newLocation.id = response.quoraId;
        return newLocation;
    }
    get id() {
        return this.getValue(dcterms_1.dcterms.identifier);
    }
    set id(val) {
        this.overwrite(dcterms_1.dcterms.identifier, new models_1.Literal(`${val}`));
    }
    get name() {
        return this.getValue(dcterms_1.dcterms.title);
    }
    set name(val) {
        this.overwrite(dcterms_1.dcterms.title, new models_1.Literal(val));
    }
    get geotype() {
        return this.getValue(titan_ads_1.titanAds.geotype);
    }
    set geotype(val) {
        this.overwrite(titan_ads_1.titanAds.geotype, new models_1.Literal(val));
    }
};
exports.Location = Location;
Location.targetClass = titan_ads_1.titanAds.Location;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: dcterms_1.dcterms.identifier,
        required: true,
        dataType: xsd_1.xsd.string,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Location.prototype, "id", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: dcterms_1.dcterms.title,
        required: true,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Location.prototype, "name", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.geotype,
        required: true,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Location.prototype, "geotype", null);
exports.Location = Location = Location_1 = __decorate([
    package_1.linkedShape
], Location);
//# sourceMappingURL=Location.js.map